import ApiService from './ApiService';

class PaymentApi extends ApiService {
    constructor() {
        super('payment');
    }

    /**
     * Get GMO payment URL
     * @param data Payment data including publicationIds, priceTotal, taxTotal, grandTotal
     */
    getPaymentUrl(data: {
        publicationIds: string[],
        priceTotal: number,
        taxTotal: number,
        grandTotal: number
    }) {
        // payments/url is a separate endpoint at root level, not under /payment
        // Use a new ApiService instance with empty base URL to call absolute path
        const paymentUrlApi = new ApiService();
        return paymentUrlApi.post('payments/url', data);
    }
}

export const paymentApi = new PaymentApi();
export default PaymentApi;
